import { render, staticRenderFns } from "./sqqy.vue?vue&type=template&id=5108fc3e&scoped=true&"
import script from "./sqqy.vue?vue&type=script&lang=js&"
export * from "./sqqy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108fc3e",
  null
  
)

export default component.exports